<template>
  <th class="px-5" nowrap>
    <slot />
  </th>
</template>

<style scoped lang="scss">
@import "@/designSystem/Table/cx-table.scss";
</style>
